var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"media-displayer-single-gallery"},[_c(_vm.displayTypeComponent,{tag:"component",attrs:{"gallery":_vm.gallery},on:{"openGallery":function($event){return _vm.$emit('openGallery', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }